var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDockSide({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dock Side"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3334 3.33334H1.66669V16.6667H18.3334V3.33334ZM16.6667 5.00001H3.33335V15H16.6667V5.00001Z",
    fill: "#145DA0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    x: 10,
    y: 5.83334,
    width: 5.83333,
    height: 8.33333,
    fill: "#145DA0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDockSide);
export default __webpack_public_path__ + "static/media/dock_side.96a3402608d4409b15719e6cc3237c8c.svg";
export { ForwardRef as ReactComponent };